import React from 'react';
import Header from './Header';
import Footer from './Footer';

const Layout = ({ children }) => (
  <div className="font-body grain min-h-screen bg-[#0b0b0d]">
    <Header />
    <main className="relative z-10">{children}</main>
    <Footer />
  </div>
);

export default Layout;
